<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4 relative">
  
  <div class="absolute inset-0 overflow-hidden pointer-events-none">
    <div class="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-br from-[#BF7A7A]/10 to-[#6E7E97]/10 rounded-full blur-3xl"></div>
    <div class="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-tr from-[#6E7E97]/10 to-[#BF7A7A]/10 rounded-full blur-3xl"></div>
  </div>

  <div class="w-full max-w-md animate-fade-in relative z-10">
    
    <div class="text-center mb-8">
      <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-[#BF7A7A] to-[#6E7E97] mb-4 shadow-lg">
        <lucide-icon name="car" class="w-8 h-8 text-white"></lucide-icon>
      </div>
      <h1 class="text-2xl md:text-3xl font-semibold text-slate-800">
        Добре дошли отново
      </h1>
      <p class="text-slate-500 mt-2 text-base md:text-lg">
        Влезте, за да достъпите таблото си
      </p>
    </div>

    <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-6 md:p-8">
      
      <div *ngIf="errorMessage" class="mb-6 p-4 rounded-xl bg-red-50 border border-red-200 flex items-start gap-3 animate-slide-up">
        <lucide-icon name="alert-circle" class="w-5 h-5 text-red-500 shrink-0 mt-0.5"></lucide-icon>
        <p class="text-sm text-red-600 font-medium">{{ errorMessage }}</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-5">
        
        <div class="space-y-2">
          <label for="username" class="text-slate-700 font-medium text-base">
            Потребителско име
          </label>
          <div class="relative">
            <div class="absolute left-4 top-1/2 -translate-y-1/2 flex items-center pointer-events-none">
              <lucide-icon name="user" class="w-5 h-5 text-slate-400"></lucide-icon>
            </div>
            <input
              type="text"
              id="username"
              formControlName="username"
              placeholder="Въведете потребителско име"
              class="w-full pl-12 h-14 text-base md:text-lg rounded-xl border border-slate-300 focus:outline-none focus:border-[#BF7A7A] focus:ring-1 focus:ring-[#BF7A7A] bg-white transition-colors"
              [class.border-red-500]="username?.invalid && (username?.touched || isSubmitted)"
            />
          </div>
          <p *ngIf="username?.invalid && (username?.touched || isSubmitted)" class="text-sm text-red-500 mt-1">
            Потребителското име е задължително.
          </p>
        </div>

        <div class="space-y-2">
          <label for="password" class="text-slate-700 font-medium text-base">
            Парола
          </label>
          <div class="relative">
             <div class="absolute left-4 top-1/2 -translate-y-1/2 flex items-center pointer-events-none z-10">
              <lucide-icon name="lock" class="w-5 h-5 text-slate-400"></lucide-icon>
            </div>
            
            <input
              [type]="showPassword ? 'text' : 'password'" 
              id="password"
              formControlName="password"
              placeholder="Въведете вашата парола"
              class="w-full pl-12 pr-12 h-14 text-base md:text-lg rounded-xl border border-slate-300 focus:outline-none focus:border-[#BF7A7A] focus:ring-1 focus:ring-[#BF7A7A] bg-white transition-colors"
              [class.border-red-500]="password?.invalid && (password?.touched || isSubmitted)"
            />

            <button
              type="button"
              (click)="togglePasswordVisibility()"
              class="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none transition-colors"
            >
              <lucide-icon 
                [name]="showPassword ? 'eye-off' : 'eye'" 
                class="w-5 h-5">
              </lucide-icon>
            </button>
          </div>
          
          <p *ngIf="password?.invalid && (password?.touched || isSubmitted)" class="text-sm text-red-500 mt-1">
            Паролата е задължителна (минимум 6 символа).
          </p>
        </div>

        <button
          type="submit"
          [disabled]="isLoading"
          class="w-full h-14 text-base md:text-lg font-medium rounded-xl bg-gradient-to-r from-[#BF7A7A] to-[#6E7E97] hover:from-[#A86969] hover:to-[#5D6D86] text-white shadow-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-75 disabled:cursor-not-allowed"
        >
          <ng-container *ngIf="isLoading; else loginText">
            <lucide-icon name="loader-2" class="w-5 h-5 animate-spin"></lucide-icon>
            Влизане...
          </ng-container>
          <ng-template #loginText>
            Вход
            <lucide-icon name="arrow-right" class="w-5 h-5"></lucide-icon>
          </ng-template>
        </button>

      </form>
    </div>

    <p class="text-center text-sm text-slate-500 mt-6">
      Само за вътрешни потребители. Свържете се с администратора за достъп.
    </p>
  </div>
</div>